export default {
  // btn
  site_btn_info: 'Save Info',
  site_btn_back: 'Back',

  // site
  site_title: 'Site',
  site_overview: 'Overview',
  site_device: 'Device',
  site_fault: 'Fault',
  site_event: 'Event',
  site_info_title: 'Site Info',
  site_info_customer: 'Affiliated Customer',
  site_info_status: 'Status',
  site_info_build_date: 'Build Date',
  site_info_address: 'Address',
  site_info_notification: 'Notification Receiver',
  site_device_status: 'Device Status Distribution',
  site_device_total: 'Total',
  site_device_offline: 'Offline',
  site_device_online_offline: 'Online / Offline',
  site_device_alarming: 'Alarm',
  site_events: 'Events',

  site_device_category_charging: 'EV Charger',
  site_device_category_charging_ac: 'AC Charger',
  site_device_category_charging_energy: 'Storage Charger',
  site_device_category_energy: 'Storage Device',
  site_device_category_energy_home: 'Home Storage',
  site_device_category_v2g: 'V2G Charger',

  // List
  site_table_name: 'Site Name',
  site_table_devices_number: 'Number of Devices',
  site_table_divices_offline_number: 'Number of Offline Devices',
  site_table_warning_state: 'Warning State',
  site_table_user: 'Operating User',
  site_table_time: 'Time',
  site_table_operation: 'Operation Type',

  // Detail tabs
  site_tab_status_statistics: 'Status Statistics',
  site_tab_traffic_statistics: 'Traffic Statistics',
  site_tab_cumulative_statistics: 'Cumulative Traffic',
  site_tab_admin_list: 'Admin List',

  // Admin list
  site_table_admin_name: 'Admin Name',
  site_table_admin_role: 'Role',
  site_table_admin_alarm: 'Notification Receiver',
  site_table_admin_addtime: 'Add Time',

  // confirm
  site_confirm_delete_title: 'Delete this site?',
  site_confirm_delete_description:
    'If there are devices bound to this site, deletion is not allowed',
  site_confirm_diabled_title: 'Disable this site?',
  site_confirm_enabled_title: 'Enable this site?',
  site_confirm_content: 'Site Name: {name}',

  // Form
  site_form_belong_customer: 'Affiliated Customer',
  site_form_belong_customer_placeholder: 'Please select an affiliated customer',
  site_form_name: 'Site Name',
  site_form_name_placeholder: 'Please enter the site name',
  site_form_image: 'Image',
  site_form_code: 'Site Code',
  site_form_code_placeholder: 'Please enter the site code',
  site_form_contact: 'Contact Person',
  site_form_contact_placeholder: 'Please enter the contact person',
  site_form_phone: 'Contact Phone',
  site_form_phone_placeholder: 'Please enter the contact phone',
  site_form_build_date_placeholder: 'Please select the build date',
  site_form_address_placeholder: 'Please enter the address',
  site_form_user_placeholder: 'Please enter keywords: such as admin name, role name',
  site_form_notification_placeholder: 'Please select the notification receiver',

  // tabs
  site_tabs_edit_event: 'Site Edit Event',
  site_tabs_device_edit_event: 'Device Edit Event',
  site_tabs_device_control_event: 'Device Control Event',
  site_tabs_device_config_event: 'Device Configuration Event',
};
